<template>
  <div class="policy">
    <div class="policy-banner">
      <p>政策文件</p>
    </div>
    <!-- <listTitle label="政策文件"></listTitle> -->
    <div class="policy-list-box">
      <listPolicy :policyList="textlist"></listPolicy>
    </div>
    <!-- <pageSelect
      :total="total"
      :page="page"
      :pageSize="pageSize"
      :pagePrev="pagePrev"
      :pageNext="pageNext"
      @setpage="setPage"
      @setpagesize="setPageSize"
    ></pageSelect>-->
    <paging
      :total="total"
      :page="page"
      :pageSize.sync="pageSize"
      :pagePrev="pagePrev"
      :pageNext="pageNext"
      @changepage="setPage"
      @changepagesize="setPageSize"
    ></paging>
  </div>
</template>
<script>
// import listTitle from "@/components/listTitle.vue";
import listPolicy from "@/components/listPolicy.vue";
import paging from "@/components/paging.vue";
// import pageSelect from "@/components/pageSelect.vue";
export default {
  props: {
    areacode: {
      type: [String, Number],
      default: "00",
    },
  },
  components: {
    // listTitle,
    listPolicy,
    paging,
    // pageSelect
  },
  data() {
    return {
      textlist: [],
      total: 0,
      page: 1, //当前页
      pageSize: 30, //显示条数
      pagePrev: "前一页",
      pageNext: "后一页",
    };
  },
  mounted() {
    // this.initGetPolicyList();
  },
  watch: {
    areacode: {
      immediate: true,
      handler(newValue) {
        this.initGetPolicyList();
      },
    },
  },
  methods: {
    initGetPolicyList() {
      this.$axios({
        url: "api/getArticleList",
        type: "get",
        params: {
          areacode: this.areacode,
          page: this.page,
          pageSize: this.pageSize,
        },
      })
        .then((res) => {
          this.textlist = res.data.articleList;
          this.total = res.data.totalCount;
        })
        .catch((err) => {
          console.info(err);
        });
    },
    setPage(page) {
      this.page = page;
      this.initGetPolicyList();
    },
    setPageSize(value) {
      this.pageSize = value;
      this.page = 1;
      this.initGetPolicyList();
    },
  },
};
</script>
<style lang="scss" scoped>
.policy {
  width: 100%;
  height: auto;
  position: relative;
  // background: linear-gradient(90deg, #ffffff, transparent, transparent);
  // padding: 10px 0;
  .policy-banner {
    width: 100%;
    height: 200px;
    background-image: url("./../../assets/bg.png");
    background-position: center center;
    background-repeat: no-repeat;
    p {
      width: 1200px;
      height: 200px;
      line-height: 200px;
      font-size: 30px;
      text-align: left;
      left: 0;
      right: 0;
      margin: auto;
      color: #ffffff;
      font-family: 微软雅黑;
      font-weight: bold;
      padding: 0 30px;
    }
  }
  .policy-list-box {
    width: 1200px;
    height: auto;
    left: 0;
    right: 0;
    margin: auto;
    padding: 0 80px;
  }
}
</style>